import { render } from "./PopUpContratto.vue?vue&type=template&id=150b0a63"
import script from "./PopUpContratto.vue?vue&type=script&lang=js"
export * from "./PopUpContratto.vue?vue&type=script&lang=js"

import "./PopUpContratto.vue?vue&type=style&index=0&id=150b0a63&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\es.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__